export default "__VITE_ASSET__CnCOG1JK__"